var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.54 4.54a.65.65 0 0 1 .92 0l7 7a.65.65 0 0 1 0 .92l-7 7a.65.65 0 1 1-.92-.92l5.89-5.89H5a.65.65 0 1 1 0-1.3h12.43l-5.89-5.89a.65.65 0 0 1 0-.92Z",
    fill: "currentColor"
  })));
};

export { Svg24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS41NDA0IDQuNTQwMzhDMTEuNzk0MiA0LjI4NjU0IDEyLjIwNTggNC4yODY1NCAxMi40NTk2IDQuNTQwMzhMMTkuNDU5NiAxMS41NDA0QzE5LjcxMzUgMTEuNzk0MiAxOS43MTM1IDEyLjIwNTggMTkuNDU5NiAxMi40NTk2TDEyLjQ1OTYgMTkuNDU5NkMxMi4yMDU4IDE5LjcxMzUgMTEuNzk0MiAxOS43MTM1IDExLjU0MDQgMTkuNDU5NkMxMS4yODY1IDE5LjIwNTggMTEuMjg2NSAxOC43OTQyIDExLjU0MDQgMTguNTQwNEwxNy40MzA4IDEyLjY1SDVDNC42NDEwMSAxMi42NSA0LjM1IDEyLjM1OSA0LjM1IDEyQzQuMzUgMTEuNjQxIDQuNjQxMDEgMTEuMzUgNSAxMS4zNUgxNy40MzA4TDExLjU0MDQgNS40NTk2MkMxMS4yODY1IDUuMjA1NzggMTEuMjg2NSA0Ljc5NDIyIDExLjU0MDQgNC41NDAzOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";